import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/userReducer';
import gamesReducer from './reducers/gamesReducer';
import appReducer from './reducers/appReducer';
import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from 'redux-logger';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import {languageDetectorMiddleware} from "../middlewares/languageDetectorMiddleware";

const userPersistConfig = {
	key: 'user',
	storage: storage,
};

const appPersistConfig = {
	key: 'app',
	storage: storage,
	whitelist: ['language', 'theme'],
};
const cartPersistConfig = {
	key: 'cart',
	storage: storage,
	timeout: 50000,
};

const rootReducer = combineReducers({
	user: persistReducer(userPersistConfig, userReducer),
	games: persistReducer(cartPersistConfig, gamesReducer),
	app: persistReducer(appPersistConfig, appReducer),
});

const middleware = [thunkMiddleware, languageDetectorMiddleware];
if (process.env.NODE_ENV === 'development') {
	middleware.push(loggerMiddleware);
}

const store = configureStore({
	reducer: rootReducer,
	middleware,
});

const persistor = persistStore(store);

export { store, persistor };
